import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalOpts } from './confirmation-modal.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: false,
})
export class ConfirmationModalComponent implements OnInit {
  public readonly data = inject<ModalOpts>(MAT_DIALOG_DATA);
  public readonly dialogRef = inject<MatDialogRef<ConfirmationModalComponent>>(MatDialogRef);

  public additionalMessage = '';

  ngOnInit(): void {
    if (this.data.initialValue !== undefined) {
      this.additionalMessage = this.data.initialValue;
    }
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public save(): void {
    if (this.data.additionalMessage) {
      this.dialogRef.close(this.additionalMessage);
    } else {
      this.dialogRef.close(true);
    }
  }
}
